var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 14.25C1.375 14.25 0.25 14.25 0.25 13.125C0.25 12 1.375 8.625 7 8.625C12.625 8.625 13.75 12 13.75 13.125C13.75 14.25 12.625 14.25 12.625 14.25H1.375ZM7 7.5C7.89511 7.5 8.75355 7.14442 9.38649 6.51149C10.0194 5.87855 10.375 5.02011 10.375 4.125C10.375 3.22989 10.0194 2.37145 9.38649 1.73851C8.75355 1.10558 7.89511 0.75 7 0.75C6.10489 0.75 5.24645 1.10558 4.61351 1.73851C3.98058 2.37145 3.625 3.22989 3.625 4.125C3.625 5.02011 3.98058 5.87855 4.61351 6.51149C5.24645 7.14442 6.10489 7.5 7 7.5Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageProfile);
export default __webpack_public_path__ + "static/media/ManageProfile.257fcb1e42a190957b3aa786a025f714.svg";
export { ForwardRef as ReactComponent };